import { Box, Typography } from "@material-ui/core";
import { format, subSeconds } from "date-fns";
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
// import useDataResource from "../../../hooks/useDataResource/useDataResource";
import LoadingDots from "../../../LoadingDots/LoadingDots";
import NoDataAvailable from "../../../NoDataAvailable";
import { MeterDropdown } from "../MeterDropdown/MeterDropdown";
import ChannelsGraph from "./ChannelsGraph/ChannelsGraph";
// import ChannelsGraph from "./ChannelsGraph/ChannelsGraph";
import { DeterminateDivider } from "./DeterminiteDivider";
import {
  LiveMeterGraphDropdownContainer,
  LiveMeterGraphHeaderContainer,
} from "./LiveMeterGraph.styles";
import { formatData, getRecentData } from "./LiveMeterGraph.utils";

const defaultDuration = 30000; // default every 30 secs

// sorry if this is confusing -- only had 1 day to do it
export const LiveMeterGraph = ({ meters, selectedMeterIndex, api }) => {
  const [currentData, setCurrentData] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [error, setError] = useState(false);

  const currentMeterIndex = useRef();
  const currentSeriesNames = useRef();
  const duration = useRef(defaultDuration);

  // fetching
  const fetchData = async () => {
    setFetching(true);
    const isNewMeter = selectedMeterIndex !== currentMeterIndex.current;
    currentMeterIndex.current = selectedMeterIndex;
    try {
      const data = await api.call('meters', 'getShortEnergy', [meters[selectedMeterIndex].id]);

      // handle duration
      if (duration.current !== data.duration) {
        duration.current = data.duration * 1000;
      }

      // handle getting new data
      const { formattedData, seriesNames } = formatData(
        data.data,
        data.channels
      );
      currentSeriesNames.current = seriesNames;
      const newDataSplit =
        !isNewMeter && currentData
          ? getRecentData(formattedData, currentData)
          : formattedData;

      setCurrentData(newDataSplit);
      setFetching(false);
    } catch (error) {
      console.error(error);
      setError(error);
      setFetching(false);
    }
  };

  // initial fetch
  useEffect(() => {
    setCurrentData([]);
    setError(false);
    (async () => await fetchData())();
  }, [meters, selectedMeterIndex]);

  // re-fetches
  useEffect(() => {
    let fetchingInterval;
    if (currentData && !fetching) {
      fetchingInterval = setTimeout(
        async () => await fetchData(),
        duration.current
      );
    }
    return () => clearTimeout(fetchingInterval);
  }, [meters, currentData, fetching, selectedMeterIndex]);

  return (
    <Box marginTop={3}>
      {!error ? (
        <Fragment>
          <DeterminateDivider
            delay={duration.current}
            fetching={fetching}
            reset={currentData || selectedMeterIndex || fetching}
          />
          {currentData.length && currentSeriesNames.current ? (
            <ChannelsGraph
              data={currentData}
              selectedMeterIndex={selectedMeterIndex}
              duration={duration.current}
              seriesNames={currentSeriesNames.current}
            />
          ) : (
            <Box height="400px" width="100%">
              <div className="h-100 w-100 aspect-ratio-content text-center d-flex flex-column justify-content-center align-items-center">
                <LoadingDots spinnerClass="bg-primary" />
              </div>
            </Box>
          )}
        </Fragment>
      ) : (
        <NoDataAvailable
          additionalInfo={
            error.status === 401 ? (
              <p className="p-0">
                It looks like you are unauthorized to view this channel data.
                <br />
                Your session may have expired, try logging out and in again.
              </p>
            ) : error.status === 404 ? (
              <p>This meter doesn't appear to support live data.</p>
            ) : null
          }
        />
      )}
    </Box>
  );
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/LiveMeterGraph/LiveMeterGraph.js